import React, {useState} from 'react';
import {Redirect} from 'react-router-dom'
import {useOktaAuth} from '@okta/okta-react'

export function CustomLoginCallback() {
    // Store error here so we can display it to the user.
    let [errorMessage, setErrorMessage] = useState<any>();
    const {oktaAuth, authState} = useOktaAuth();

    React.useEffect(() => {
        // Tell Okta to handle the callback.
        oktaAuth.handleLoginRedirect()
            .catch((err) => {
                console.log('Error handleLoginRedirect promise: ', err)
                if (err && err.errorSummary) {
                    setErrorMessage(`${err.name || 'OAuth Error'}: ${err.errorCode}. ${err.errorSummary}`);
                } else {
                    setErrorMessage(err + '')
                }
            });
    }, [oktaAuth]);

    if (!authState.isPending && authState.error) {
        errorMessage = authState.error + ''
    }

    // If we got an error, redirect to login and pass the error
    if (errorMessage) {
        return <Redirect to={{
            pathname: '/login',
            state: {error: errorMessage},
        }}/>
    } 

    // Else do nothing, okta will redirect to the page the user was on.
    return null;
}